import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { converterCategories } from "../data/tools";
import { AdSlot } from "../components/AdSlot";
import { SectionLabel } from "../components/SectionLabel";
import { usePageMeta } from "../lib/usePageMeta";

export default function ConvertersIndex() {
  usePageMeta(
    "Unit Converters — Length, Weight, Temperature & More | Utiliverse",
    "Free online unit converters for length, weight, temperature, volume, area, speed, digital storage and time."
  );
  return (
    <div>
      <section className="bp-grid border-b-2 border-ink">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14">
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-signal mb-3">Tool Category</p>
          <h1 className="font-heading font-black text-5xl sm:text-6xl tracking-tighter">Unit Converters</h1>
          <p className="mt-4 text-lg text-ink/70 max-w-2xl">Pick a category to convert instantly. Each set generates hundreds of precise conversion pages.</p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-0 border-t-2 border-l-2 border-ink">
          {converterCategories.map((cat) => {
            const Icon = cat.icon;
            return (
              <Link
                key={cat.id}
                to={`/converters/${cat.id}`}
                data-testid={`converter-index-${cat.id}`}
                className="group border-b-2 border-r-2 border-ink bg-paper p-8 hover:bg-canvas transition-colors relative"
              >
                <span className="w-12 h-12 border-2 border-ink bg-canvas flex items-center justify-center mb-5 group-hover:bg-signal group-hover:text-paper transition-colors">
                  <Icon className="w-6 h-6" strokeWidth={2.2} />
                </span>
                <h3 className="font-heading font-bold text-2xl tracking-tight">{cat.label}</h3>
                <p className="text-sm text-ink/60 mt-1">{cat.blurb}</p>
                <p className="font-mono text-[11px] uppercase tracking-widest text-ink/40 mt-4">{cat.units.length} units</p>
                <ArrowRight className="w-5 h-5 absolute top-8 right-8 opacity-0 group-hover:opacity-100 group-hover:translate-x-1 transition-all" />
              </Link>
            );
          })}
        </div>
        <div className="mt-12"><AdSlot format="leaderboard" testid="converters-ad" /></div>
      </div>
    </div>
  );
}
